import { computed } from 'vue'

export const useEnvironment = () => {
  const config = useRuntimeConfig()
  const currentEnvironemnt = ref(import.meta.env?.VITE_APP_ENV)

  const isProduction = computed(() => {
    return currentEnvironemnt.value === 'production'
  })

  const isMaintainceMode = computed(() => {
    return config.public?.VITE_APP_MAINTENANCE_MODE === true || config.public?.VITE_APP_MAINTENANCE_MODE === 'true'
  })

  return {
    currentEnvironemnt,
    isProduction,
    isMaintainceMode,
  }
}
